// axios
import axios from 'axios'

const backendUrl = process.env.VUE_APP_BACKEND_URL
console.log("backendUrl : " + backendUrl)
const accessToken = localStorage.getItem('accessToken')
  // load the accesstoken from the localStorage and add it as default header
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`

export default axios.create({
  baseURL: backendUrl
  // You can add your headers here
})
